import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface PlanAccionSiniestro {
  id?: number;
  id_investigacion: number;
  id_siniestro: number;
  id_causa?: number | null;
  tipo_accion: "CORRECTIVA" | "PREVENTIVA" | "MEJORA";
  descripcion_accion: string;
  responsable: string;
  fecha_compromiso: string;
  fecha_cumplimiento?: string | null;
  estado?: "PENDIENTE" | "EN_CURSO" | "CERRADA" | "VENCIDA";
  recursos_requeridos?: string;
  observaciones?: string;
  ResponsableAccionData?: { cedula: string; nombreCompleto: string };
}

@Injectable({ providedIn: "root" })
export class PlanAccionSiniestroService {
  private apiUrl = `${environment.apiUrl}/api/plan-accion-siniestro`;

  constructor(private http: HttpClient) {}

  getByInvestigacionId(idInvestigacion: number | string): Observable<PlanAccionSiniestro[]> {
    return this.http
      .get<PlanAccionSiniestro[]>(`${this.apiUrl}/investigacion/${idInvestigacion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: number | string): Observable<PlanAccionSiniestro> {
    return this.http
      .get<PlanAccionSiniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: PlanAccionSiniestro[]): Observable<PlanAccionSiniestro[]> {
    return this.http
      .post<PlanAccionSiniestro[]>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<PlanAccionSiniestro>): Observable<PlanAccionSiniestro> {
    return this.http
      .put<PlanAccionSiniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}